import * as React from 'react';
import { Component, CSSProperties, ReactNode } from 'react';
import * as classNames from 'classnames';
import * as _ from 'lodash';
import TrackVisibility from 'react-on-screen';

import AdvertisingComponent from '../component/index';

interface IContainerProps {
  className?: string;
  style?: CSSProperties;
  config: any;
  type: string;
  scriptSrc: any;
}
interface IContainerInjectedProps {
  config: any;
  type: string;
  scriptSrc: any;
}

export default class Container extends Component<IContainerProps, {}> {
  constructor(props) {
    super(props);
  }

  // public get injected(): IContainerInjectedProps {
  //   return this.props as IContainerInjectedProps;
  // }

  public render(): ReactNode {
    const { type, config, scriptSrc } = this.props;
    return (
      <TrackVisibility partialVisibility once>
        {({isVisible}) => {
          return (
            <AdvertisingComponent config={config} type={type} scriptSrc={scriptSrc}/>
          );
        }}
      </TrackVisibility>
    );
  }
}
